import compact from 'lodash/compact'
import {
  GeckoComponentModel,
  GeckoComponentModelType,
  GeckoLegacyCone,
  GeckoMeasurement,
  GeckoMeasurementRange,
  GeckoMeasurementUnit,
  GeckoTankFlatRoof,
  GeckoTankFloor,
  GeckoVerticalTankShell,
} from 'types'

export function getNominalRangeFromTankFlatRoofOrFloor(
  componentModel: GeckoTankFloor | GeckoTankFlatRoof
): GeckoMeasurementRange | undefined {
  if (!componentModel.baseNominalThickness) {
    return undefined
  }

  return GeckoMeasurementRange.CreateFromStartEnd(
    componentModel.baseNominalThickness,
    componentModel.baseNominalThickness
  )
}

export function getNominalRangeFromTankShell(
  componentModel: GeckoVerticalTankShell
): GeckoMeasurementRange | undefined {
  return getNominalRangeFromCourses(componentModel.coursesArray)
}

export function getNominalRangeFromLegacyCone(
  componentModel: GeckoLegacyCone
): GeckoMeasurementRange | undefined {
  return getNominalRangeFromCourses(componentModel.coursesArray)
}

function getNominalRangeFromCourses(
  courses: { wallNominalThickness?: GeckoMeasurement }[]
): GeckoMeasurementRange | undefined {
  if (!courses || courses.length === 0) {
    return GeckoMeasurementRange.CreateFromStartEnd(
      GeckoMeasurement.CreateFromValue(0, GeckoMeasurementUnit.Inches),
      GeckoMeasurement.CreateFromValue(0, GeckoMeasurementUnit.Inches)
    )
  }

  const nominals = compact(courses.map((course) => course.wallNominalThickness))

  if (nominals.length === 0) {
    return undefined
  }

  const min = GeckoMeasurement.Min(...nominals)
  const max = GeckoMeasurement.Max(...nominals)

  return GeckoMeasurementRange.CreateFromStartEnd(min, max)
}

export const getComponentNominalRange = (
  componentModel: GeckoComponentModel
): GeckoMeasurementRange | undefined => {
  switch (componentModel.type) {
    case GeckoComponentModelType.VerticalTankShell:
      return getNominalRangeFromTankShell(componentModel)
    case GeckoComponentModelType.LegacyCone:
      return getNominalRangeFromLegacyCone(componentModel)
    case GeckoComponentModelType.TankFloor:
    case GeckoComponentModelType.TankFlatRoof:
      return getNominalRangeFromTankFlatRoofOrFloor(componentModel)
    default:
      return undefined
  }
}
